// extracted by mini-css-extract-plugin
module.exports = {"white":"src_white__2jTo8","blue":"src_blue__28_Nc"};